import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../constants/api';

export const testimonialsApi = createApi({
  reducerPath: 'testimonialsApi',
  baseQuery: fetchBaseQuery({ baseUrl: API_BASE_URL }),
  endpoints: (builder) => ({
    listTestimonials: builder.query({
      query: () => '/testimonials',
      transformResponse: (raw) => raw?.testimonials ?? [],
    }),
  }),
});

export const { useListTestimonialsQuery } = testimonialsApi;
